import { render } from "./SummaryChart.vue?vue&type=template&id=436aef27"
import script from "./SummaryChart.vue?vue&type=script&lang=js"
export * from "./SummaryChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__